﻿var StickyStack = require('StickyStack');
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
// Import of creatApp from Vue 3 bundler and axios for API requests.
import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');
import { setCookie, getCookie, deleteCookie, debounce } from '../functions';
import eventBlock from './Vue/eventBlock.vue';

document.addEventListener('DOMContentLoaded', () => {
    // Only build the Vue instance if the targeted element is present.
    if (document.getElementById('agenda')) {
        const agendaApp = createApp({
            components: {
                eventBlock
            },
            // The data object returns data-attribute values instantiated in HTML and general properties for loading state, 
            // the data object with facets and resulting items, the view toggler for results, the current 'page' and textual search input binding.
            data() {
                return {
                    dataApi: '',
                    apiType: '',
                    dataLimit: 15, // Default limit in BE
                    dataSort: [],
                    dataAmountsSentence: '',
                    firstLoad: true,
                    loading: true,
                    chunkLoad: false,
                    fetchDataBusy: false,
                    data: {
                        items: [],
                        facets: []
                    },
                    ignorefacets: [],
                    blockView: false,
                    page: 1,
                    daterange: '',
                    searchText: '',
                    searchQuery: '',
                    searchFrom: '',
                    searchTo: '',
                    searchDateLabel: '',
                    monthFilterName: '',
                    monthFilterTitle: '',
                    unwatchDate: false
                }
            },
            watch: {
                daterange(newdaterange, olddaterange) {
                    if (!this.unwatchDate) {
                        if (newdaterange !== '') {
                            let dateValues = newdaterange.split(',');
                            this.searchFrom = dateValues[0];
                            this.searchTo = dateValues[1];
                            this.searchDateLabel = dateValues[2];
                        } else {
                            this.searchFrom = '';
                            this.searchTo = '';
                            this.searchDateLabel = '';
                        }
                        this.page = 1;
                        this.fetchData(true);
                    }
                },
                blockView(newView, oldView) {
                    if (newView) {
                        setCookie('AgendaBlockView', 'true', 365);
                    } else {
                        deleteCookie('AgendaBlockView');
                    }
                },
                searchText(...args) {
                    this.debouncedFetch(...args);
                },
                searchQuery(newVal, oldVal) {
                    if (newVal !== oldVal) {
                        this.page = 1;
                        this.fetchData(true);
                    }
                }
            },
            // The computed object holds checks for facets set, filters chosen and filters active.
            // Furthermore, reactive properties for orderItems, filterItems and the queryModel are kept track of.
            computed: {
                facetsSet() {
                    return this.data && this.data.facets && this.data.facets.length;
                },
                filtersChosen() {
                    return this.facetsSet && this.data.facets.some(facet => facet.values.length);
                },
                filtersActive() {
                    return this.facetsSet && (this.data.facets.some(facet => facet.selected) || this.searchQuery.length || (this.searchFrom.length && this.searchTo.length) || this.daterange !== '');
                },
                filterItems() {
                    //let typeFilter = { Key: 'agendaType.keyword', Values: [this.apiType], Operator: 'eq' };
                    //if (!this.filtersChosen && !this.searchFrom && !this.searchTo) return [typeFilter];

                    let tempFilterArray = this.data.facets.filter(facet => facet.values.length).map(facet => {
                        return {
                            Key: facet.alias,
                            Values: facet.values,
                            Operator: 'In'
                        }
                    });
                    

                   
                    if (this.searchFrom && this.searchTo) {
                        //tempFilterArray.push({
                        //    Key: 'firstStartDate',
                        //    Values: [this.searchFrom],
                        //    Operator: 'Gt'
                        //},
                        //{
                        //    Key: 'firstStartDate',
                        //    Values: [this.searchTo],
                        //    Operator: 'Lt'
                        //});
                        let startDateSearch = new Date(this.searchFrom);
                        let monthQuery = startDateSearch.getFullYear() + "-" + ('0' + (startDateSearch.getMonth() + 1)).slice(-2);
                        tempFilterArray.push({
                            Key: 'months.keyword',
                            Values: [monthQuery],
                            Operator: 'in'
                        });
                    }
                    //tempFilterArray.push(typeFilter);
                    return tempFilterArray;
                },
                queryModel() {
                    return {
                        Limit: this.dataLimit,
                        Offset: this.chunkLoad ? 0 : (this.page - 1) * this.dataLimit,
                        OrderItems: this.dataSort,
                        FilterItems: this.filterItems,
                        Text: this.searchQuery
                    }
                },
                amountsSentence() {
                    return this.dataAmountsSentence.replace('{{queryCount}}', this.data.queryCount).replace('{{totalCount}}', this.data.totalCount);
                },
                monthButtons() {
                    let dateFacet = this.data.facets.find(facet => facet.alias === this.monthFilterName);
                    if (!dateFacet) return [];

                    let dateOptions = dateFacet.options.map(option => {
                        option.valueAlias = option.valueAlias.replace(' ', 'T');
                        return option;
                    });

                    dateOptions = dateOptions.filter(option => new Date(option.valueAlias).getYear() !== new Date('9999-12-31T23:59:59').getYear());
                    this.monthFilterTitle = dateFacet.title
                    if (!dateOptions.length) return [];
                    else {
                        let firstDate = new Date(dateOptions[0].valueAlias);
                        let lastDate = new Date(dateOptions[dateOptions.length - 1].valueAlias);
                        lastDate.setMonth(lastDate.getMonth() + 1);
                        let monthButtons = [];
                        let date = new Date(firstDate);
                        do {
                            if (new Date(date.getFullYear(), date.getMonth() + 1, 0) >= new Date(date.getFullYear(), date.getMonth(), 1)) {
                                monthButtons.push({
                                    year: date.getFullYear(),
                                    month: date.getMonth(),
                                    label: date.toLocaleDateString('nl-NL', { month: 'short' }).replace('.', ''),
                                    from: new Date(date.getFullYear(), date.getMonth(), 1).toISOString(),
                                    to: new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString(),
                                    disabled: !dateOptions.some(option =>
                                        new Date(option.valueAlias).getFullYear() === date.getFullYear() &&
                                        new Date(option.valueAlias).getMonth() === date.getMonth())
                                })
                            }
                            date.setMonth(date.getMonth() + 1);
                        }
                        while ((date.getFullYear() !== lastDate.getFullYear()) || (date.getMonth() !== lastDate.getMonth()))

                        return monthButtons;
                    }
                }
            },
            methods: {
                // The fetchData method fetches and handles API data, mainly facets and resulting items. 
                // The parameters ensure the method can be called in different ways.
                fetchData(initial = false, filterParams = null, pageParam = 0, stateUpdate = true) {
                    /*if (initial) this.page = 1;*/
                    let tempQueryModel = { ...this.queryModel };
                    // when api use post
                    axios
                        .post(this.dataApi, this.queryModel)
                        .then(response => {
                            if (response.status === 200) {
                                // Check if the data object should be overwritten.
                                if (initial) {
                                    this.data = response.data;

                                    // Add values array to facet items, for easier access of set filters.
                                    this.data.facets = response.data.facets.map(facet => {
                                        if (facet.alias === 'genres.id.keyword') {
                                            facet.options.map(facetOption => {
                                                facetOption.text = facetOption.text.toLowerCase();
                                            });
                                        }
                                        return {
                                            ...facet,
                                            values: [],
                                        }
                                    }).filter(facet => this.ignorefacets.includes(facet.alias) == false)
                                        .sort((a, b) => a.sortOrder - b.sortOrder);
                                    // Set selected values on facets.
                                    if (tempQueryModel.FilterItems && tempQueryModel.FilterItems.length) {
                                        tempQueryModel.FilterItems.forEach(filter => {
                                            if (filter.Operator !== 'In') return;
                                            let matchingFacet = this.data.facets.find(facet => facet.alias === filter.Key);
                                            matchingFacet.selected = true;
                                            matchingFacet.values = filter.Values;
                                            filter.Values.forEach(value => {
                                                matchingFacet.options.find(option => option.valueAlias === value).selected = true;
                                            })
                                        })
                                    }
                                    // Check if preset filters were given in the URL or the initial load should yield more than 1 data chunk.
                                    if (filterParams) {
                                        return { action: 'PREFILTER', payload: filterParams };
                                    }
                                    //else if (pageParam && pageParam > 1) {
                                    //    return { action: 'LOADMORE', payload: pageParam };
                                    //}
                                }
                                // If no overwrite, add items to the existing items array. This is for lazy loading purposes.
                                else {
                                    response.data.items.forEach(item => this.data.items.push(item));
                                    this.data.queryCount = response.data.queryCount;

                                    this.fetchDataBusy = false;
                                }

                                // Push state to browser URL.
                                if (stateUpdate) this.updateUrl();
                            }
                        })
                        .then(resolve => {
                            // Handle preset filters and/or loading more data chunks in initial page load.
                            if (resolve && resolve.action) {
                                switch (resolve.action) {
                                    case 'PREFILTER':
                                        this.data.facets.forEach(facet => {
                                            if (resolve.payload.has(facet.title)) {
                                                let values = resolve.payload.get(facet.title).split(',');
                                                values.forEach(value => {
                                                    if (facet.options.find(option => option.text === value)) {
                                                        facet.values.push(facet.options.find(option => option.text === value).valueAlias)
                                                    }
                                                })
                                            }
                                            if (facet.alias === this.monthFilterName && resolve.payload.has('date')) {
                                                this.unwatchDate = true;
                                                let dateValue = resolve.payload.get('date');
                                                if (this.monthButtons.some(month => month.label + month.year === dateValue)) {
                                                    let month = this.monthButtons.find(month => month.label + month.year === dateValue);
                                                    this.searchDateLabel = month.label + month.year;
                                                    this.searchFrom = month.from;
                                                    this.searchTo = month.to;
                                                    this.daterange = month.from + ',' + month.to + ',' + this.searchDateLabel;
                                                }
                                                this.$nextTick(() => {
                                                    this.unwatchDate = false;
                                                });
                                            }
                                        });
                                        this.fetchData(true, null, pageParam, false);
                                        break;
                                    case 'LOADMORE':
                                        
                                        //for (this.page; this.page <= resolve.payload; this.page++) {
                                        //    this.fetchData(false, null, 0, false);
                                        //}
                                        //this.page--;
                                        break;
                                    default:
                                        break;
                                }
                            }
                        })
                        .catch(error => console.log(error))
                        // Set loading prop to false when done.
                        .finally(() => this.loading = false);
                },
                // Lazy loading data chunks handler.
                loadMore() {
                    this.page++;
                    this.fetchDataBusy = true;
                    this.fetchData();
                },
                groupedFacetOptions(facet) {
                    let groupedOptions = [];
                    groupedOptions.push(facet.options.reduce(function (option, val) {
                        if (val.category !== '') {
                            option[val.category] = option[val.category] || [];
                            option[val.category].push(val);
                            return option;
                        } else {
                            option['noCategory'] = option['noCategory'] || [];
                            option['noCategory'].push(val);
                            return option;
                        }
                    }, Object.create(null))
                    );
                    return groupedOptions
                },
                // Data alteration function for reloading data with set filters.
                selectOption(facetAlias, event) {
                    let optionAlias = event.target.value;
                    let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
                    changedFacet.values = [optionAlias];
                    this.page = 1;
                    this.fetchData(true);
                },
                removeSelect(facetAlias) {
                    let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
                    changedFacet.values = [];
                    this.page = 1;
                    this.fetchData(true);
                },
                selectCustomDate() {
                    this.searchFrom = from;
                    this.searchTo = to;
                    this.searchDateLabel = label;
                    this.page = 1;
                    this.fetchData(true);
                },
                // Data alteration function for resetting all active filters and reloading data.
                reset() {
                    this.data.facets.forEach(facet => { facet.values = []; facet.selected = false;  facet.options.forEach(option => option.selected = false) });
                    this.searchText = '';
                    this.page = 1;
                    if (this.daterange !== '') {
                        this.daterange = '';
                    } else {
                        this.fetchData(true);
                    }
                },
                // Function for updating browser URL and state history with changed filters, search input or page.
                updateUrl() {
                    if (!this.queryModel.Text && !this.queryModel.FilterItems.length && this.page === 1) {
                        history.pushState({}, null, window.location.pathname);
                        return;
                    }
                    const urlParams = new URLSearchParams();
                    if (this.queryModel.Text) urlParams.append('text', this.queryModel.Text);
                    if (this.searchDateLabel) urlParams.append('date', this.searchDateLabel);

                    if (this.queryModel.FilterItems.length) {
                        this.queryModel.FilterItems
                            .filter(filterItem => filterItem.Operator === 'In')
                            .forEach(filterItem => {
                                let facet = this.data.facets.find(facet => facet.alias === filterItem.Key);
                                urlParams.append(
                                    facet.title,
                                    facet.options.filter(option => filterItem.Values.includes(option.valueAlias)).map(option => option.text).join());
                            })
                    }

                    if (this.page > 1) urlParams.append('page', this.page);
                    history.pushState({}, null, window.location.pathname + '?' + urlParams.toString());
                },
                redirect(url) {
                    if (url) window.location.href = url;
                },

                // Check if a new month should be shown in the template and return the display value if so.
                showMonth(index, date) {
                    let returnVal = null;
                    if (index === 0) {
                        returnVal = new Intl.DateTimeFormat('nl-NL', { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
                    }
                    else {
                        let prevEvent = this.data.items[index - 1];
                        if (prevEvent) {
                            if (this.toDateObj(date).getMonth() !== this.toDateObj(prevEvent.firstStartDate).getMonth() || this.toDateObj(date).getYear() !== this.toDateObj(prevEvent.firstStartDate).getYear()) {
                                returnVal = new Intl.DateTimeFormat('nl-NL', { month: 'long' }).format(this.toDateObj(date)) + ' ' + this.toDateObj(date).getFullYear();
                            }
                        }
                    }
                    return returnVal;
                },
                // Check if a new year should be shown in the template and return the display value if so.
                showYear(index, date) {
                    return index === 0 || this.toDateObj(date).getMonth() === 0 ? this.toDateObj(date).getFullYear() : null;
                },
                // Simple whitespace strip function.
                strip(value) {
                    if (!value) return '';
                    value = value.toString();
                    return value.replace(/\s/g, '');
                },
                // Simple date object handler.
                toDateObj(dateString) {
                    return new Date(dateString);
                },
                // Simple short month year string handler for date.
                toMonthYearStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { month: 'short', year: 'numeric' });
                },
                // Simple short year string handler for date.
                toYearStr(dateString) {
                    return new Date(dateString).toLocaleDateString('nl-NL', { year: 'numeric' });
                },
                // Simple date string handler for time.
                toTimeStr(dateString, endDateString) {
                    let startTime = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
                    let endTime = endDateString ? new Date(endDateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' }) : null;
                    return endTime ? startTime + ' - ' + endTime : startTime;
                },
                // Simple date string handler.
                toDateStr(dateString) {
                    let date = new Date(dateString).toLocaleDateString('nl-NL', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
                    let time = new Date(dateString).toLocaleTimeString('nl-NL', { hour: 'numeric', minute: 'numeric' });
                    return date.replace('.', '') + ' | ' + time;
                },
                // Data alteration function for reloading data with set filters.
                toggleOption(facetAlias, optionAlias) {
                    let changedFacet = this.data.facets.find(facet => facet.alias === facetAlias);
                    if (changedFacet.values.includes(optionAlias)) {
                        changedFacet.values = changedFacet.values.filter(value => value !== optionAlias);
                    } else {
                        changedFacet.values.push(optionAlias);
                    }
                    this.page = 1;
                    this.fetchData(true);
                }
            },
            created() {
                if (getCookie('AgendaBlockView') !== "") {
                    this.blockView = false;
                }
                //window.addEventListener("unload", (event) => {
                //    setCookie('scrollPos-' + this.apiType, window.scrollY, 1);
                //});
                this.debouncedFetch = debounce((newValue, oldValue) => {
                    if (newValue.length > 2) {
                        this.searchQuery = newValue;
                    } else {
                        this.searchQuery = '';
                    }
                });

            },
            mounted() {
                // Set data props according to data attributes in HTML template.
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
                if (this.$el.dataset.sort) this.dataSort = JSON.parse(this.$el.dataset.sort);
                if (this.$el.dataset.showxamountoftotalitems) this.dataAmountsSentence = this.$el.dataset.showxamountoftotalitems;
                if (this.$el.dataset.type) this.apiType = this.$el.dataset.type;
                if (this.$el.dataset.monthfilter) this.monthFilterName = this.$el.dataset.monthfilter;
                if (this.$el.dataset.ignorefacets) this.ignorefacets = this.$el.dataset.ignorefacets.split(',');
                // Construct query model and alter data props based on URL search params.
                const urlParams = new URLSearchParams(window.location.search);

                let pageParam = urlParams.has('page') ? parseInt(urlParams.get('page')) : 0;
                if (pageParam) urlParams.delete('page');
                if (pageParam < 2) pageParam = 0;
                this.searchText = urlParams.has('text') ? urlParams.get('text') : '';
                if (this.searchText) urlParams.delete('text');
                let filterParams = urlParams.toString() ? urlParams : null;
                if (pageParam) {
                    this.firstLoad = false;
                    this.page = pageParam;
                    let oldLimit = this.dataLimit;
                    this.chunkLoad = true;
                    this.dataLimit = this.dataLimit * this.page;
                    this.$nextTick(() => {
                        this.firstLoad = true;
                        this.fetchData(true, filterParams, 0);
                    });
                } else {
                    this.fetchData(true, filterParams, 0);
                }
            },
            updated() {
                if (this.firstLoad) {
                    this.$nextTick().then(() => {
                        const stickyStack0 = new StickyStack(['.facet-container']);
                        const $facetFormContainer = document.getElementById('facet-form-container');
                        const facetCollapsibleInstances = bulmaCollapsible.attach('.facet-field, .facet-form-container');
                        if (window.innerWidth > 1240) {
                            var totalHeight = 0;
                            var children = $facetFormContainer.children;
                            for (var i = 0; i < children.length; i++) {
                                totalHeight += parseInt(children[i].offsetHeight, 10);
                            }
                            $facetFormContainer.style.height = totalHeight + 'px';
                        } else {
                            $facetFormContainer.style = "";
                            $facetFormContainer.style.height = $facetFormContainer.offsetHeight + 'px';
                        }
                        //if (getCookie('scrollPos-' + this.apiType) !== "") {
                        //    window.scrollTo(parseInt(getCookie('scrollPos-' + this.apiType)), 0);
                        //    deleteCookie('scrollPos-' + this.apiType);
                        //}
                        this.firstLoad = false;
                        this.dataLimit = parseInt(this.$el.dataset.limit);
                        this.chunkLoad = false;
                    });
                }
            },
        });

        // Mount the app on the targeted element.
        agendaApp.mount('#agenda');
    }
});

